import React, { useEffect, useRef, useState } from "react";

const DecompositionAnimation = ({ isActive }) => {
  const [step, setStep] = useState(0);
  const [cutProgress, setCutProgress] = useState(0); // 0..1 reveal of the diagonal

  // unique ID for the clipPath (safe for multiple mounts)
  const clipIdRef = useRef(`cutReveal-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    if (!isActive) {
      setStep(0);
      return;
    }
    const id = setInterval(() => setStep((s) => (s + 1) % 3), 1500);
    return () => clearInterval(id);
  }, [isActive]);

  // start smooth reveal when step==1; reset at 0, full at 2
  useEffect(() => {
    if (step === 0) {
      setCutProgress(0);
      return;
    }
    if (step >= 2) {
      setCutProgress(1);
      return;
    }
    // step === 1 -> animiere 0 -> 1 in ~800ms
    let raf = 0;
    const D = 800;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / D);
      setCutProgress(p);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [step]);

  const showCut = step >= 1;
  const separated = step >= 2;

  // Diagonale: Start/End-Punkte (gleich wie bei dir)
  const x1 = 27, y1 = 19;
  const x2 = 92, y2 = 80;

  // Clip-Breite entlang X (reicht, da x entlang der Linie strikt zunimmt)
  const clipW = x1 + (x2 - x1) * cutProgress + 0.5; // +0.5 als kleiner Puffer

  return (
    <div className="rounded-lg overflow-hidden flex items-center justify-center">
      <svg
        viewBox="0 0 120 105"
        className="block"
        width="100%"
        height="100%"
        style={{ backgroundColor: "#db2777" }}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        {/* --- Clip for the diagonal line --- */}
        <defs>
          <clipPath id={clipIdRef.current} clipPathUnits="userSpaceOnUse">
            {/* rectangular reveal: from x=0 to clipW, full height */}
            <rect x="0" y="0" width={clipW} height="100" />
          </clipPath>
        </defs>

        {/* Matrix-Klammern */}
        <line x1="15" y1="10" x2="15" y2="90" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="105" y1="10" x2="105" y2="90" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="15" y1="12" x2="25" y2="12" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="15" y1="88" x2="25" y2="88" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="105" y1="12" x2="95" y2="12" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="105" y1="88" x2="95" y2="88" stroke="#f3f4f6" strokeWidth="4" />

        {/* Unteres linkes „L“-Dreieck */}
        <polygon
          points="25,78 25,25 82,78"
          fill="none"
          stroke="#f3f4f6"
          strokeWidth="4"
          style={{
            transition: "transform 0.8s",
            transform: separated ? "translate(-8px,8px)" : "translate(0,0)",
          }}
        />

        {/* Oberes rechtes „U/R“-Dreieck */}
        <polygon
          points="38,22 95,22 95,75"
          fill="none"
          stroke="#f3f4f6"
          strokeWidth="4"
          style={{
            transition: "transform 0.8s",
            transform: separated ? "translate(8px,-8px)" : "translate(0,0)",
          }}
        />

        {/* Diagonal-Schnitt: gestrichelt + progressiver Reveal */}
        {showCut && (
          <g clipPath={`url(#${clipIdRef.current})`}>
            <line
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="#f3f4f6"
              strokeWidth="2"
              strokeDasharray="4 4"
            />
          </g>
        )}
      </svg>
    </div>
  );
};

export default DecompositionAnimation;
